import React from "react";
import "../Components/Assets/CSS/Contact.css";
import shankimg from "../Components/Assets/Images/6.jpg";
import Aboutcover from "../Components/Assets/Images/Aboutcover.webp";
import convertInterior from "../Components/Assets/Images/halfTransCity.png";
 
const About = () => {
  return (
    <div>
      <div class="image-container" />
      <img class="bg-image" src={Aboutcover} alt="Background" />
 
      <div className="about-section">About us</div>
 
      <div className="about-container">
        <div className="hero1">
          <h2>Wings of Responsibility.</h2>
          <br></br>
          <p>
            Shankh Air is India’s newest full-service airline, created with a
            clear purpose — to redefine domestic air travel with the comfort,
            care, and convenience found in leading global carriers.. Shankh Air
            is proud to operate India’s most fuel-efficient fleet — built for
            sustainability, speed, and safety. From the moment you book with us
            to the moment you land, every touchpoint is designed to reflect
            world-class service with Indian warmth. With transparent pricing,
            tech-enabled processes, and human-first hospitality, we’re building
            an airline that’s easy to trust — and hard to forget. Our team
            listens, anticipates needs, and adapts quickly — because to us,
            travel isn’t just transportation, it’s transformation.
          </p>
        </div>
        <div className="hero">
          <img className="styled-img" src={convertInterior} alt="Interior" />
        </div>
      </div>
 
      {/* hero 2 */}
      <div className="about-container">
        <div className="hero-image">
          <img className="styled-img" src={shankimg} alt="Shankh" />
        </div>
 
        <div className="hero-content">
          <h2>Our Priority</h2>
          <br></br>
          <p>
            What sets us a part is not just what we do, but how we do it—guided
            by our five core values: Safety First, Service with Soul, Unity in
            Action, Grace with Grit, and Relentless Reliability. Our work
            culture is guided by five fundamental values: Safety Above All,
            Consistency with Care, Service that Connects, Humility in Action,
            and Collective Strength. These values define who we are and how we
            serve—with heart, precision, and unity.
            <br></br>
          </p>
          <h4>
            This isn’t just another flight. This is your sky. Welcome aboard
            Shankh Air.
          </h4>
        </div>
      </div>
      <div className="about-container">
        <div className="hero1">
          <h2>Soaring With Heart</h2>
          <br></br>
          <p>
            At Shankh Air, we believe that our journey begins with our people.
            Every successful takeoff, smooth landing, and memorable in-flight
            experience is made possible by the passion and dedication of our
            workforce. Every smile at check-in, every safe landing, and every
            effortless journey is made possible by our dedicated team who go
            above and beyond for our flyers. Our team is made up of dynamic,
            highly trained individuals who are committed to redefining air
            travel for modern India—ensuring every traveler feels seen, heard,
            and cared for.
          </p>
        </div>
        <div className="hero">
          <img className="styled-img" src={Aboutcover} alt="About" />
        </div>
      </div>
    </div>
  );
};
 
export default About;